module.exports = __webpack_public_path__ + "img/reports--avatar.6f7bae55.svg";